export const getIconColorClass = (color) => {
    switch (color) {
        case 'gray':
            return 'stroke-slate-500';
        case 'red':
            return 'stroke-red-600';
        case 'white':
            return 'stroke-white';
        case 'green':
            return 'fill-green-500';
        case 'blue':
            return 'stroke-blue-500 fill-blue-500';
        case 'original':
            return '';
        default:
            return 'stroke-slate-500';
    }
};